import { CountryLabel } from '@/domain/country/CountryLabel';
import { GeoJSON } from 'ol/format';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import { toTextStyle } from '@/primary/webmapping/country/style/CountryLabelStyle';

export const createCountryLabelFeature = (countryLabelFeature: GeoJSON.Feature<GeoJSON.Point, CountryLabel>) => {
  const countryLabelOLFeature = new Feature({
    geometry: new Point(countryLabelFeature.geometry.coordinates),
  });
  countryLabelOLFeature.setId(countryLabelFeature.properties.id);
  countryLabelOLFeature.setStyle(toTextStyle(countryLabelFeature.properties.name, -countryLabelFeature.properties.rank));
  return countryLabelOLFeature;
};

export const updateCountryLabelFeature = (countryLabelOLFeature: Feature, countryLabel: CountryLabel) => void {}; // eslint-disable-line @typescript-eslint/no-unused-vars
